export default __webpack_public_path__ + "static/media/onboardingBackground2.274d52ff.png";